import styled from "styled-components";
import TextFieldView from "../commons/TextField.view";
import BaseModal from "../modal/Base.modal";
import { useState } from "react";


type ChangeSubscriptionProps = {
  onClickCancel: () => void
  onClickConfirm: () => void
}


export default function ChangeSubscriptionModal(props: ChangeSubscriptionProps) {

  const [isAgree, setIsAgree] = useState(false)

  return (
    <BaseModal
      title="월 자문료 변경"
      onClickLeftButton={props.onClickCancel}
      onClickRightButton={props.onClickConfirm}
      rightButtonText="변경하기"
      isDisableRightButton={!isAgree}
    >
      <ChangeSubscriptionDiv className="card_middle">
        <ul>
          <li>이용자는 아래 변경 버튼을 눌러 정기자문료를 월 10만 원에서 월 5만 원으로 변경할 수 있습니다.</li>
          <li>정기자문료를 변경할 경우(정기자문료 월 5만 원을 납부할 경우), 이용자는 서비스 종류에 따라 추가자문료를 납부하여야 할 수 있습니다(자세한 추가자문료 금액은 약관과 홈페이지 참조).</li>
          <li>정기자문료를 변경하지 아니할 경우(정기자문료 월 10만 원을 납부할 경우), 이용자는 기존과 동일하게 추 가자문료 없이 모든 서비스를 이용할 수 있습니다.</li>
          <li>이용자가 정기요금제를 월 10만 원에서 월 5만 원으로 변경하더라도, 가입기간은 최초 가입한 때부터 산정합니다.</li>
        </ul>
        <div className="checkbx">
          <input type="checkbox" id="check1"
            checked={isAgree}
            onChange={e => setIsAgree(e.target.checked)}
          />
          <label htmlFor="check1">
            <span className="checkmark" />
            <p>이용자는 이용약관을 읽고 확인하였으며, 정기자문료 월 10만 원에서 월 5만 원으로 변경 신청합니다.</p>
          </label>
        </div>
      </ChangeSubscriptionDiv>
    </BaseModal>
  )
}

const ChangeSubscriptionDiv = styled.section`
  max-width: 480px;
  border-top: 1px solid #eee;
  ul{
    list-style-type: disc;
    padding-inline-start: 14px;
    li{
      line-height: 1.5;
      + li{
        margin: 12px 0 0 0;
      }
    }
  }

  .checkbx{
    margin: 36px 0 0;
  }
`